import React from 'react'
import { Link } from 'react-router'

function IssueIdLink({ issue, children }) {
    const i = issue.issue || issue
    return <Link to={`/issues/${i.issueId}`}>{children}</Link>
}

export default IssueIdLink
